import axios from 'axios'

export default class UserApi {
    constructor(api) {
        this.$api = api
    }

    login(params) {
        return axios({ url: '/user/login', method: 'post', data: params })
    }

    register(params) {
        return axios({ url: '/user/register', method: 'post', data: params })
    }

    logout(params) {
        return axios({ url: '/user/logout', method: 'post', data: params })
    }

    accountGetInfo(params) {
        return axios({ url: '/user/accountGetInfo', method: 'post', data: params })
    }

    accountUpdate(params) {
        return axios({ url: '/user/accountUpdate', method: 'post', data: params })
    }

}



// WEBPACK FOOTER //
// ./src/api/UserApi.js